"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MessageBarTransition", {
    enumerable: true,
    get: function() {
        return MessageBarTransition;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reacttransitiongroup = require("react-transition-group");
const _messageBarTransitionContext = require("../../contexts/messageBarTransitionContext");
const getClassName = (status, enterClassName, exitClassName, animate)=>{
    switch(status){
        case 'entering':
        case 'entered':
            return animate === 'both' ? enterClassName : '';
        case 'exiting':
        case 'exited':
            return exitClassName;
        default:
            return '';
    }
};
const MessageBarTransition = ({ children, enterClassName, exitClassName, animate, ...rest })=>{
    const nodeRef = _react.useRef(null);
    return /*#__PURE__*/ _react.createElement(_reacttransitiongroup.Transition, {
        timeout: 250,
        nodeRef: nodeRef,
        ...rest
    }, (state)=>/*#__PURE__*/ _react.createElement(MessageBarTransitionInner, {
            animate: animate,
            enterClassName: enterClassName,
            exitClassName: exitClassName,
            nodeRef: nodeRef,
            state: state
        }, children));
};
const MessageBarTransitionInner = ({ children, state, enterClassName, exitClassName, animate, nodeRef })=>{
    const className = getClassName(state, enterClassName, exitClassName, animate);
    const context = _react.useMemo(()=>({
            className,
            nodeRef
        }), [
        className,
        nodeRef
    ]);
    return /*#__PURE__*/ _react.createElement(_messageBarTransitionContext.MessageBarTransitionContextProvider, {
        value: context
    }, children);
};
